import {TrailerDefaultBox} from './trailer.default.box';

export const TrailerBox = TrailerDefaultBox;